
/**
 * @author liu
 * @date 2019/11/19/019
 * @Description: 只给表格用
*/
<template>
  <span class="caret-wrapperL" @click="changeStatus">
    <i class="descending" :class="{active:digStatus==1}"></i>
    <i class="ascending" :class="{active:digStatus==0}"></i>
  </span>
</template>

<script>
    export default {
        name: "arrowSort",
      props: {
        order: {
          type: Number,
          default: () => 0
        }
      },
      computed: {
        digStatus: {
          get() {
            return this.order;
          },
          set(value) {
            this.$emit("update:order", value);
          }
        }
      },
      methods:{
        changeStatus(){
          this.digStatus = this.digStatus==0?1:0
          this.$emit('research')
        }
      }
    }
</script>

<style lang="less" scoped>
  .caret-wrapperL{
    margin-left: -4px;
    cursor: pointer;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    height: 20px;
    width: 14px;
    vertical-align: middle;
    overflow: initial;
    position: relative;
  .descending{
    border-top-color: #c0c4cc;
    bottom: 0px;
    &.active{
      border-top-color: @primaryColor;
    }
  }
  .ascending{
    border-bottom-color: #c0c4cc;
    top: -2px;
    &.active{
      border-bottom-color: @primaryColor;
    }
  }
  i{
    width: 0;
    height: 0;
    border: 5px solid transparent;
    position: absolute;
    left: 7px;

  }
  }
</style>
